import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "shell-nav",
  role: "banner"
};
const _hoisted_2 = {
  class: "shell-nav__inner"
};
const _hoisted_3 = {
  class: "shell-brand__wordmark"
};
const _hoisted_4 = {
  class: "shell-nav__links",
  "aria-label": "Primary"
};
const _hoisted_5 = {
  class: "shell-nav__end"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_AccountMenu = _resolveComponent("AccountMenu");
  const _component_BottomTabBar = _resolveComponent("BottomTabBar");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-shell", {
      'app-shell--no-chrome': $options.hideChrome
    }])
  }, [!$options.hideChrome ? (_openBlock(), _createElementBlock("header", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
    to: $options.brandHref,
    class: "shell-brand",
    "aria-label": "CDNone"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_3, _toDisplayString($options.brandText), 1)]),
    _: 1
  }, 8, ["to"]), _createElementVNode("nav", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.primaryItems, item => {
    return _openBlock(), _createBlock(_component_router_link, {
      key: item.to,
      to: item.to,
      class: _normalizeClass(["shell-nav__link", {
        'is-active': $options.isActive(item)
      }])
    }, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
        size: 16,
        weight: $options.isActive(item) ? 'bold' : 'regular',
        "aria-hidden": "true"
      }, null, 8, ["weight"])), _createElementVNode("span", null, _toDisplayString(item.label), 1)]),
      _: 2
    }, 1032, ["to", "class"]);
  }), 128))]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_AccountMenu, {
    items: $options.accountItems,
    "is-admin": _ctx.adminLoggedIn,
    onSelect: $options.handleAccountSelect
  }, null, 8, ["items", "is-admin", "onSelect"])])])])) : _createCommentVNode("", true), _createElementVNode("main", {
    class: _normalizeClass(["shell-main", {
      'shell-main--padded': !$options.hideChrome
    }])
  }, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)], 2), !$options.hideChrome ? (_openBlock(), _createBlock(_component_BottomTabBar, {
    key: 1,
    items: $options.primaryItems,
    active: $options.activeTabKey,
    class: "shell-tabbar"
  }, null, 8, ["items", "active"])) : _createCommentVNode("", true)], 2);
}